import { ReactComponent as UndoIcon } from "../../img/undo.svg";
import { INITIAL_STATE, resetOrderState, GlobalStore } from "../../store/global/GlobalStore";

import React, { useCallback } from "react";

export const ResetButton: React.FC = () => {
  const theme = GlobalStore.useState(s => s.theme);
  const { makerTokens, takerTokens } = GlobalStore.useState(s => {
    return {
      makerTokens: s.makerTokens,
      takerTokens: s.takerTokens,
    };
  });

  const isResetApplicable = useCallback(() => {
    if (takerTokens.length !== INITIAL_STATE.takerTokens.length || makerTokens.length > 0) {
      return true;
    }
    const tokensHaveChanged = takerTokens.some((token, index) => {
      return (
        INITIAL_STATE.takerTokens[index].token !== token.token &&
        !INITIAL_STATE.takerTokens[index].amount.value.eq(token.amount.value)
      );
    });
    return tokensHaveChanged;
  }, [makerTokens.length, takerTokens]);

  return isResetApplicable() ? (
    <UndoIcon
      style={{ cursor: "pointer", color: theme.button.primary.surface.active }}
      onClick={resetOrderState}
    />
  ) : null;
};
